import { useMemo } from 'react';

import type { EditorClassificationTagWrapperProps } from '../EditorComponentsV2/EditorClassificationTagWrapper.tsx';

export const useShouldRenderEditorActionBarClassificationPlaceholder = (
	props: EditorClassificationTagWrapperProps,
): boolean => {
	const { contentClassificationMetadata } = props;

	const { hasNoClassification, contentLevelLoading } = contentClassificationMetadata;

	const classificationEnabledFinalEvaluation =
		contentClassificationMetadata?.featureEnabled ?? false;

	return useMemo(() => {
		if (!classificationEnabledFinalEvaluation) return false;
		if (hasNoClassification) return false;
		if (contentLevelLoading) return false;
		return true;
	}, [contentLevelLoading, hasNoClassification, classificationEnabledFinalEvaluation]);
};
